var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[(_vm.user)?_c('p',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }